import { render, staticRenderFns } from "./UnidadesMedidasFormComponent.vue?vue&type=template&id=3dd2febe&"
import script from "./UnidadesMedidasFormComponent.vue?vue&type=script&lang=js&"
export * from "./UnidadesMedidasFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports